import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function Hero() {
  return <section className="pt-6 pb-8 px-4 relative overflow-hidden" data-id="element-153">
      <div className="max-w-md sm:max-w-lg mx-auto text-center relative z-10" data-id="element-154">
        <motion.div initial={{
        opacity: 0,
        y: -10
      }} animate={{
        opacity: 1,
        y: 0
      }} className="inline-flex items-start gap-2 bg-brand-card border border-brand-danger/40 px-3 py-2 rounded-2xl mb-5" data-id="element-155">
          <span className="w-2 h-2 mt-1.5 rounded-full bg-brand-danger animate-pulse shrink-0" data-id="element-156" />
          <span className="text-[10px] sm:text-xs font-black tracking-wider text-brand-danger uppercase leading-snug text-left" data-id="element-157">
            ⚠️ ATTENZIONE: DOCENTI E PROFESSIONISTI TECNICI CHE SACRIFICANO LE
            PROPRIE SERATE A PIANIFICARE
          </span>
        </motion.div>

        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.05
      }} className="text-[26px] sm:text-4xl font-black text-brand-cream leading-[1.1] mb-4" data-id="element-158">
          La formazione tecnica{' '}
          <span className="relative inline-block" data-id="element-159">
            <span className="bg-gradient-to-r from-brand-orange to-brand-amber bg-clip-text text-transparent" data-id="element-160">
              Smart Home
            </span>
            <span className="absolute left-0 right-0 -bottom-1 h-[3px] bg-gradient-to-r from-brand-orange to-brand-amber rounded-full" data-id="element-161" />
          </span>{' '}
          del futuro è <span className="text-brand-gold" data-id="element-162">già pronta.</span>
        </motion.h1>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.1
      }} className="bg-brand-card border-l-4 border-brand-orange rounded-r-xl p-4 sm:p-5 mb-6 text-left" data-id="element-163">
          <p className="text-sm sm:text-base text-gray-300 leading-snug mb-2" data-id="element-164">
            Tutto il materiale tecnico pronto per insegnare{' '}
            <span className="text-brand-orange font-bold" data-id="element-165">
              Domotica, Smart Home e Building Automation
            </span>{' '}
            senza improvvisare.
          </p>
          <p className="text-sm sm:text-base text-gray-300 leading-snug" data-id="element-166">
            L'unico ecosistema didattico{' '}
            <span className="text-brand-cream font-bold" data-id="element-167">"chiavi in mano"</span>{' '}
            per docenti ed esperti che vogliono trasformare un'aula in un{' '}
            <span className="text-brand-cream font-bold" data-id="element-168">
              laboratorio professionale
            </span>{' '}
            in soli 5 minuti.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        delay: 0.15
      }} className="mb-6" data-id="element-169">
          <a href="#pricing" className="block cursor-pointer" data-id="element-170">
            <img src="https://cdn.magicpatterns.com/uploads/iJzop9sfU9VLscJDKNK71H/ChatGPT_Image_20_may_2026,_18_17_23.png" alt="Sistema Domotica e Smart Home Pro — Archivio Tecnico Completo" className="w-full h-auto object-contain drop-shadow-2xl" data-id="element-171" />
          </a>
        </motion.div>

        <motion.p initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 0.18
      }} className="text-sm font-bold text-brand-cream mb-3" data-id="element-172">
          Sistema Domotica e Smart Home Pro — Archivio Tecnico Completo
        </motion.p>

        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 0.2
      }} className="flex items-center justify-center gap-2 mb-3 flex-wrap" data-id="element-173">
          <div className="flex" data-id="element-174">
            {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-5 h-5 text-brand-gold fill-current drop-shadow-[0_0_6px_rgba(251,191,36,0.6)]" data-id="element-175" />)}
          </div>
          <span className="text-sm font-bold text-brand-cream" data-id="element-176">
            4.9/5 (+500 Recensioni Verificate)
          </span>
        </motion.div>

        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 0.25
      }} className="inline-flex items-center gap-2 border border-brand-orange/40 bg-brand-orange/5 px-4 py-1.5 rounded-full mb-5" data-id="element-177">
          <span className="text-sm font-bold text-brand-orange" data-id="element-178">
            🔥 47 professionisti hanno scelto questo Sistema oggi
          </span>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.3
      }} data-id="element-179">
          <CTAButton className="w-full" data-id="element-180">
            ACCEDI AL SISTEMA ORA — INIZIA SUBITO
          </CTAButton>
        </motion.div>

        <div className="flex flex-wrap justify-center items-center gap-x-3 gap-y-1 mt-5 text-xs text-gray-400 font-medium" data-id="element-181">
          <span data-id="element-182">⚡ Accesso Immediato</span>
          <span className="text-gray-600" data-id="element-183">•</span>
          <span data-id="element-184">🛡️ Garanzia 7 Giorni</span>
          <span className="text-gray-600" data-id="element-185">•</span>
          <span data-id="element-186">💳 Pagamento Unico</span>
        </div>

        <div className="mt-6 flex flex-col items-center gap-2" data-id="element-187">
          <div className="w-7 h-7 rounded-full overflow-hidden border border-white/20 shadow" data-id="element-188">
            <img src="https://flagcdn.com/w80/it.png" alt="Italia" className="w-full h-full object-cover" data-id="element-189" />
          </div>
          <p className="text-[11px] text-gray-500 font-medium" data-id="element-190">
            🇮🇹 La risorsa N.1 scelta da oltre 300 docenti in tutta Italia.
          </p>
        </div>
      </div>
    </section>;
}